import { Link } from 'react-router-dom';
import ContactUsButton from './ContactUsButton';
import { useTranslation } from 'react-i18next';
import { Product } from '../data/products';
import React from 'react';
import ImageOptimized from './ImageOptimized';

interface ProductCardProps {
  product: Product;
  showPrice?: boolean;
}

const ProductCard: React.FC<ProductCardProps> = ({ product, showPrice = true }) => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language as 'en' | 'he';

  return (
    <Link
      to={`/products/${product.id}`}
      className="bg-white rounded-xl shadow p-4 flex flex-col items-center group h-full justify-between"
      style={{ minHeight: 340 }}
      onClick={(e) => {
        // If the click target is a ContactUsButton, prevent navigation
        const target = e.target as HTMLElement;
        if (target.closest('button')) {
          e.preventDefault();
        }
      }}
    >
      <ImageOptimized
        src={product.image}
        alt={product.translations[currentLang].name}
        className="w-full h-48 object-cover mb-4 transition-transform duration-300 group-hover:scale-110"
        loading="lazy"
        priority={false}
      />
      <div
        className="text-lg font-semibold mt-2 text-center w-full line-clamp-2"
        style={{ maxWidth: '100%' }}
        title={product.translations[currentLang].name}
      >
        {product.translations[currentLang].name}
      </div>
      {product.previous_price && (
        <div className="text-gray-400 text-sm line-through mb-1">
          {t('products.previousPrice', { price: product.previous_price.toLocaleString() })}
        </div>
      )}
      <div className="flex-grow" />
      <div className="w-full mt-4 flex justify-center">
        {showPrice && typeof product.price === 'number' ? (
          <div className="text-gray-900 font-extrabold text-xl">₪ {product.price.toLocaleString()}</div>
        ) : (
          <ContactUsButton 
            className="w-full" 
            onClick={(e: React.MouseEvent<HTMLButtonElement>) => e.stopPropagation()} 
          />
        )}
      </div>
    </Link>
  );
};

export default ProductCard; 